import { createI18n } from 'vue-i18n'
import en from './locales/en'
import sv from './locales/sv'

const i18n = createI18n({
  legacy: false,
  locale: 'sv',
  fallbackLocale: 'en',
  messages: {
    en,
    sv,
  },
})

export default i18n

